import React from 'react'

function PrepaidRecharge() {
    return (
        <div>PrepaidRecharge</div>
    );
}

export default PrepaidRecharge; 